import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'stylesheets/x508.scss';
import 'stylesheets/magic/amalgamation.scss';
import 'stylesheets/autoload/autoload.scss';
import 'stylesheets/new_registration.scss';
import 'javascripts/application';

import 'javascripts/app/registration'

const importAll = (r) => r.keys().map(r);
importAll(require.context('../images', true, /\.(png|jpe?g|svg)$/));

// Conditionally load download manager if the element exists
document.addEventListener('DOMContentLoaded', function() {
  const downloadManagerElement = document.getElementById('download-manager');
  if (downloadManagerElement) {
    import('./shared/download_manager');
  }

  // Conditionally load registration select_type functionality
  const rolesElement = document.getElementById('roles');
  if (rolesElement) {
    import('./registration/select_type');
  }

  // Conditionally load e-prescribing waiver if the element exists
  const ePrescribingWaiverElement = document.getElementById('e-prescribing-waiver');
  if (ePrescribingWaiverElement) {
    import('./waivers/e_prescribing/new');
  }
});